import { PropsWithChildren } from 'react'
import { Settings } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { StyledSlider } from 'components/Carousel/styles'

interface CarouselProps {
  settings: Settings
}

function Carousel({ settings, children }: PropsWithChildren<CarouselProps>) {
  return <StyledSlider {...settings}>{children}</StyledSlider>
}

export default Carousel
